import { render, staticRenderFns } from "./SafetyObservationPriorityListing.vue?vue&type=template&id=971fda76"
import script from "./SafetyObservationPriorityListing.vue?vue&type=script&lang=js"
export * from "./SafetyObservationPriorityListing.vue?vue&type=script&lang=js"
import style0 from "./SafetyObservationPriorityListing.vue?vue&type=style&index=0&id=971fda76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports